// extracted by mini-css-extract-plugin
export var centerAligned = "richCustomColumns-module--centerAligned--0p9lT";
export var columnItem = "richCustomColumns-module--columnItem--8BFsM";
export var columnLayout = "richCustomColumns-module--columnLayout--ad6Bt";
export var columnsWrapper = "richCustomColumns-module--columnsWrapper--8DVlX";
export var imgWrapper = "richCustomColumns-module--imgWrapper--Cg6tw";
export var itemTitle = "richCustomColumns-module--itemTitle--RKYHF";
export var leftAligned = "richCustomColumns-module--leftAligned--m0QUe";
export var richCustomColumnsContainer = "richCustomColumns-module--richCustomColumnsContainer--ScO3J";
export var rowLayout = "richCustomColumns-module--rowLayout--33oOa";
export var sbShowMain = "richCustomColumns-module--sb-show-main--eyK3p";
export var textContent = "richCustomColumns-module--textContent--p4DCY";